import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { StatusCargaService } from 'src/app/services/status-carga/status-carga.service';
import bb,{donut, gauge} from "billboard.js"
import { LocalstorageService } from 'src/app/services/storage/localstorage.service';
import JustGage from "justgage";

@Component({
  selector: 'app-status-carga-loading',
  templateUrl: './status-carga-loading.component.html',
  styleUrls: ['./status-carga-loading.component.scss']
})
export class StatusCargaLoadingComponent implements OnInit {

  @Input() usuarioAutenticadoP: boolean = false;
  data:any = {
      "status":false,
      "ent_read":0,
      "ent_proc":0,
      "ent_erro":0,
      "ent_qtdc":0,
  };

    gauge: any = {
    entLeitura:{
      id: "gaugeChartSatatusEnt",
      value: 0,
      min: 0,
      max: 100,
      label: "Notas lidas",
      labelFontColor: "#000000ff",
      gaugeColor: "#dee2e6",
      levelColors: ["#007bffc3"]
    },
    saiLeitura:{
      id: "gaugeChartSatatusSai",
      value: 100,
      min: 0,
      max: 100,
      label: "0%",
      labelFontColor: "#000000ff",
      gaugeColor: "#dee2e6",
      levelColors: ["#007bffc3"]
    }
  };


  pctEnt:any = 0;
  pctSai:any = 0;
  pctErro:Number = 0;
  chart:any
  sub!: Subscription;

  constructor(
    private statusCarga: StatusCargaService,
    private localStorage: LocalstorageService
  ) { }

  ngOnInit(): void {
    this.statusCarga.loadStatus();
    this.GrafGauge()
    // this.localStorage.setData('QTD_READ_BF', 0)
    this.sub = this.statusCarga.data$.subscribe(data => {
      
      this.data = data;
      if(this.data.status){
        // document.getElementById('close_carga_modal')?.click()
      }
      this.data.ent_qtdc = this.data.ent_read + this.data.ent_proc + this.data.ent_erro;
      this.data.sai_qtdc = this.data.sai_read + this.data.sai_proc + this.data.sai_erro;
      if(this.data.ent_qtdc > 0){
        let pctEntRead = Math.ceil(100 - ((this.data.ent_read * 100) / this.data.ent_qtdc));
        this.pctEnt = pctEntRead;
        this.gauge.entLeitura.refresh((this.data.ent_qtdc - this.data.ent_read), this.data.ent_qtdc);
        this.gauge.entLeitura.canvas.value.element.innerHTML = this.data.ent_read ;
        this.gauge.entLeitura.canvas.label.element.innerHTML = pctEntRead+"% Foram lidas";
        this.gauge.entLeitura.canvas.min.element.innerHTML = this.data.ent_qtdc;
        this.gauge.entLeitura.canvas.max.element.innerHTML = 0;
      }

        if(this.data.sai_qtdc > 0){ 
          let pctSaiRead = Math.ceil(100 - ((this.data.sai_read * 100) / this.data.sai_qtdc));
          this.pctSai = pctSaiRead;
          this.gauge.saiLeitura.refresh((this.data.sai_qtdc - this.data.sai_read), this.data.sai_qtdc);
          this.gauge.saiLeitura.canvas.value.element.innerHTML = this.data.sai_read ;
          this.gauge.saiLeitura.canvas.label.element.innerHTML = pctSaiRead+"% Foram lidas";
          this.gauge.saiLeitura.canvas.min.element.innerHTML = this.data.sai_qtdc;
          this.gauge.saiLeitura.canvas.max.element.innerHTML = 0;
        }
    })
  }

  GrafGauge(){
    this.gauge.entLeitura = new JustGage({...this.gauge.entLeitura})
    this.gauge.saiLeitura = new JustGage({...this.gauge.saiLeitura})
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

}
